// extracted by mini-css-extract-plugin
export default {"bold":"styles_bold__984h4"};